import { concat } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useParams } from 'react-router-dom';
import { useService } from 'react-service-locator';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import DetailedArticle from '../../components/DetailedArticle/DetailedArticle';
import { SearchService } from '../../services/search.service';
import './DetailPage.scss';

const DetailPage: React.FC = () => {
    const searchService = useService(SearchService);
    const { id } = useParams<{ id: string }>();
    const { t } = useTranslation();

    const [title, setTitle] = React.useState<string>('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        let cancelled = false;

        (async () => {
            setLoading(true);

            // Try from current page cache first
            const cached = searchService.state.result?.items.find((c) => c.pmid === id);
            if (cached) {
                if (!cancelled) {
                    setTitle(cached.title);
                    setLoading(false);
                }
                return;
            }

            // Otherwise fetch by id (you need an API endpoint for this)
            const accessToken = localStorage.getItem('accessToken');
            const date = new Date().toUTCString();
            const res = await fetch(`${process.env.REACT_APP_BASE_API_URI}/Document/get/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-ms-date': date,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!cancelled) {
                if (res.ok) {
                    const doc = await res.json();
                    setTitle(doc.title ?? '');
                }
                setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [id]);
    if (!id) return <Redirect to="/" />;
    const splitted = title.split(' ').filter(Boolean);
    const shortened =
        splitted.length <= 6 ? title : [...splitted.slice(0, 3), '[...]', ...splitted.slice(-3)].join(' ');

    return (
        <div id="detailpage" className="detail">
            <BreadCrumbs
                breadcrumbs={[
                    { to: '/', name: t('search') },
                    {
                        to: '/results',
                        name: `${searchService.state.disease ?? 'Diabetes'} ${t('search-results').toLocaleLowerCase()}`,
                    },
                    { to: `/results/${id}`, name: loading ? '...' : shortened },
                ]}
            />
            <DetailedArticle />
        </div>
    );
};

export default DetailPage;
